<template>
  <div class="text">
    <div :class="name==='多行文本'?'active text-container':'text-container'">
      <div class="sub-title">
        <span>{{ name }}</span>
        <span v-if="required" class="star">*</span>
      </div>
      <div class="phone-content">
        <span>{{ placeholder }}</span>
        <i  v-if="isSelect" class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String
    },
    /* 是否必填 */
    required: {
      type: Boolean,
      default: true
    },
    isSelect: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请输入'
    }
  },

  data() {
    return {
    }
  },

  created() {},

  methods: {
  }
}
</script>

<style lang='scss' scoped>
.phone-content {
  height: 20px;
}
</style>
